export const leaveActionTypes = {
  SET_STATE: 'leave/SET_STATE',
  GET_MANAGER_REQUESTS: 'leave/GET_MANAGER_REQUESTS',
  APPROVE_REQUEST: 'leave/APPROVE_REQUEST',
  REJECT_REQUEST: 'leave/REJECT_REQUEST',
};
